<template>
  <div
    class="rt-breadcrumb"
    aria-label="Breadcrumb"
    role="navigation"
  >
    <!-- 面包屑导航控制左右滚动到头的左右箭头 -->
    <!-- <span class="rt-breadcrumb-prev" @click="scrollPrev()"><i class="el-icon-arrow-left"></i></span>
    <span class="rt-breadcrumb-next" @click="scrollNext()"><i class="el-icon-arrow-right"></i></span> -->

    <div
      ref="breadcrumbScroll"
      class="rt-breadcrumb--wrapper"
    >
      <slot></slot>
      <!-- 给容器添加滚轮事件，完成滚轮控制左右滚动的功能 -->
      <div
        v-if="!$slots.default"
        ref="crumbItemContent"
        class="rt-breadcrumb--content"
      >
        <rt-breadcrumb-item
          v-for="(item, index) in itemsLimited"
          ref="rtbreadcrumbitem"
          :key="index + item.name"
          :prev-icon-name="item.prevIconName"
          :split-icon-name="splitIconName"
          :index="index"
          :to="item.path"
          @on-breadcrumb-click="breadcrumbClick"
        >
          {{ item.name }}
        </rt-breadcrumb-item>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RtBreadcrumb',
  props: {
    items: {
      type: Array
    },
    splitIconName: {
      type: String,
      default: 'rt-base-slash-lined'
    },
    /**
     * @public
     * 溢出时，允许最多limit个元素同时显示，不允许滚动
     */
    limit: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      originalItems: [...this.items]
    };
  },
  computed: {
    itemsLimited () {
      if (this.limit === 0) {
        return this.originalItems;
      } else {
        let processedItems = [this.originalItems[0], { name: '...' }];
        for (let i = this.originalItems.length - this.limit + 2; i <= this.originalItems.length - 1; i++) {
          processedItems.push(this.originalItems[i]);
        }
        return processedItems;
      }
    }
  },
  watch: {
    items (val) {
      this.originalItems = [...val]
    }
  },
  provide () {
    return {
      rtBreadcrumb: this
    };
  },
  methods: {
    // scrollPrev() {
    //   let currentOffset = this.$refs.breadcrumbScroll.scrollWidth;
    //   this.$refs.breadcrumbScroll.scrollTo({
    //     left: -currentOffset,
    //     behavior: 'smooth'
    //   });
    // },
    // scrollNext() {
    //   let currentOffset = this.$refs.breadcrumbScroll.scrollWidth;
    //   this.$refs.breadcrumbScroll.scrollTo({
    //     left: currentOffset,
    //     behavior: 'smooth'
    //   });
    // },
    breadcrumbClick (index) {
      if (this.limit === 0) {
        this.originalItems.splice(index + 1);
      } else {
        this.originalItems.splice(this.originalItems.length - this.limit + index + 1);
      }
      this.$emit('item-click', index, this.items[index]);
    }
    /**
     * @private
     * 给容器添加滚轮事件，完成滚轮控制左右滚动的功能
     */
    // scrollX(event) {
    //   if (this.limit === 0) this.$refs.breadcrumbScroll.scrollLeft += event.deltaY;
    // }
  }
};
</script>



// WEBPACK FOOTER //
// rtBreadcrumb.vue?0d2ed1c6